/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiSolidDashboard, BiFridge } from "react-icons/bi";
import { MdAutoMode, MdBalance, MdDeleteOutline, MdOutlineBiotech, MdOutlineEject, MdOutlineFactCheck, MdOutlineQrCode2, MdOutlineStopCircle, MdOutlineWaterDrop, MdStop, MdVerified } from "react-icons/md";
import { GrClose } from "react-icons/gr";
import { AiOutlineLeft } from "react-icons/ai";
import { IoIosNotifications } from "react-icons/io";
import logo from '../assets/images/zentem-logo-transparent.png';
import {
  MdSensorDoor,
  MdPolicy,
  MdInventory2,
  MdOutlineError,
  MdImportantDevices,
  MdOutlineSummarize,
  MdOutlineNotificationAdd,
} from "react-icons/md";
import {
  FaCog,
  FaFileDownload,
  FaFingerprint,
  FaLayerGroup,
  FaMicroscope,
  FaStop,
  FaUserFriends,
} from "react-icons/fa";
// import {BsQrCodeScan} from 'react-icons/bs'
import { BiQrScan } from "react-icons/bi";
import { SiTestcafe } from "react-icons/si";
import { ImInsertTemplate, ImLab } from "react-icons/im";
import { MdMotionPhotosAuto } from "react-icons/md";
import {
  RiFileTransferLine,
  RiLeafFill,
  RiMicroscopeFill,
} from "react-icons/ri";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import AddException from "./common/addException";
import { RiUserSettingsFill } from "react-icons/ri";
import {
  GiGears,
  GiTestTubes,
  GiThermometerScale,
  GiClockwork,
  GiAlarmClock,
  GiLightningFrequency,
  GiCuckooClock,
  GiCardDiscard,
  GiStickGrenade,
  GiTemporaryShield,
} from "react-icons/gi";
import { BsClipboardPlus, BsHouseAddFill } from "react-icons/bs";
import { AiOutlineAudit } from "react-icons/ai";
import { userService } from "../service/userService";
import { PiScales } from "react-icons/pi";
import { TbHexagonOff, TbReport, TbReportAnalytics } from "react-icons/tb";
import { GoWorkflow } from "react-icons/go";
import { FcExpired, FcInspection, FcLeave } from "react-icons/fc";
import { MdOutlinePublishedWithChanges } from "react-icons/md";
import { FaFlask, FaMagnifyingGlassLocation, FaVialCircleCheck } from "react-icons/fa6";
import { LuBookOpenCheck, LuTestTubes } from "react-icons/lu";
import { MdQrCode } from "react-icons/md";
import { HiOutlineClipboardDocument, HiOutlineDocumentChartBar } from "react-icons/hi2";
import { SlCalender } from "react-icons/sl";
import ViewSchedule from "./admin/activitySchedule/scheduleProduction/partials/viewSchedule";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { VscServerEnvironment } from "react-icons/vsc";
import { GiChemicalTank } from "react-icons/gi";
import { FaBoxes } from "react-icons/fa";
import { FaTint } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { GiPowderBag } from "react-icons/gi";
import { MdScience } from "react-icons/md";
import { MdOutlineOpacity } from "react-icons/md";
import { BsBoxSeam } from "react-icons/bs";
import { LuPackageOpen } from "react-icons/lu";
import { TfiArrowUp } from "react-icons/tfi";
import { PiStackSimpleFill, PiCheckBold } from "react-icons/pi";
import { LuPackage } from "react-icons/lu";

const Navbar = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<number | null>();
  const activeNotifi = useSelector(
    (state: RootState) => state.notification.activeNotifi
  );
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showRawMaterialModel, setShowRawMaterialModel] = useState(false);
  const [showPlateSampleModal, setShowPlateSampleModal] = useState(false);
  const [showUserEndMenu, setShowUserEndMenu] = useState(false);
  const [showAuditTrial, setAuditTrial] = useState(false);
  const [showReconciliation, setShowReconciliation] = useState(false);
  const [showconfig, setShowConfig] = useState(false);
  const [permission, setPermission] = useState<any>([]);
  const [showInventory, setShowInventory] = useState(false);
  const [showActivitySchedule, setShowActivitySchedule] = useState(false);
  const [showMediaPreparation, setShowMediaPreparation] = useState(false);
  const [showMediaInventory, setShowMediaInventory] = useState(false);
  const [showProductMaster, setShowProductMaster] = useState(false);
  const [showMediaReconciliation, setShowMediaReconciliation] = useState(false);
  const [showPostAutoclave, setShowPostAutoclave] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [tab, setTab] = useState("1");

  const navigate = useNavigate();
  const location = useLocation();
  const location_type = useSelector((state: RootState) => state.area.areaName);

  useEffect(() => {
    var storedData = localStorage.getItem("userDetails");

    if (storedData) {
      var storedObject = JSON.parse(storedData);
      getPermissionByRole(storedObject[0].role_master_id);
    }
  }, []);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    switch (index) {
      case 0:
        navigate("/adminDashboard");
        break;
      case 1:
        navigate("/areaManagement");
        break;
      case 2:
        navigate("/userManagement");
        break;
      case 3:
        navigate("/policyManagement");
        break;
      case 4:
        navigate("/plateInventory");
        break;
      case 6:
        navigate("/incubationArea");
        break;
      case 7:
        navigate("/labtestArea");
        break;
      case 8:
        navigate("/autoClave");
        break;
      case 9:
        navigate("/labOperatorDashboard");
        break;
      case 10:
        navigate("/labReport");
        break;
      case 11:
        navigate("/exceptionHandling");
        break;
      case 12:
        navigate("/scanArea");
        break;
      case 13:
        navigate("/environmental-flora");
        break;
      case 14:
        navigate("/equipmentCalibration");
        break;
      case 15:
        navigate("/addRawMaterials");
        break;
      case 16:
        navigate("/auditTrialReport");
        break;
      case 17:
        navigate("/userAccessReport");
        break;
      case 18:
        navigate("/rolesAndPermission");
        break;
      case 19:
        navigate("/addGradeType");
        break;
      case 20:
        navigate("/deviceRegistration");
        break;
      case 21:
        navigate("/logReport");
        break;
      case 22:
        navigate("/testTubeInventory");
        break;
      case 23:
        navigate("/workFlow");
        break;
      case 24:
        navigate("/visualInspectionTest");
        break;
      case 25:
        navigate("/deviationReporting");
        break;
      case 26:
        navigate("/plateReconcilation");
        break;
      case 27:
        navigate("/sopReport");
        break;
      case 128:
        navigate("/schedule_frequency");
        break;
      case 129:
        navigate("/schedule_production");
        break;
      case 130:
        navigate("/schedule_operator");
        break;
      case 131:
        navigate("/generatePlateQr");
        break;
      case 132:
        navigate("/productionCalendar");
        break;
      case 133:
        navigate("/personnelMonitoringQr");
        break
      case 134:
        navigate("/schedule_production2");
        break
      case 135:
        navigate("/schedule_operator2");
        break
      case 28:
        navigate("/reconcilationSummary");
        break;
      case 288:
        navigate("/reconcilationSummary-test");
        break;
      case 29:
        navigate("/airSamplingreport");
        break;
      case 30:
        navigate("/passiveSamplingreport");
        break;
      case 31:
        navigate("/personnelMonitoringReport");
        break;
      case 32:
        navigate("/surfaceMonitoring");
        break;
      case 33:
        navigate("/equipmentReport");
        break;
      case 34:
        navigate("/visualInspectionReport");
        break;
      case 35:
        navigate("/deviationReport");
        break;
      case 36:
        navigate("/plateActivityReport");
        break;
      case 37:
        navigate("/holidayRegister");
        break;
      case 38:
        navigate("/discard");
        break;
      case 39:
        navigate("/notificationConfiguration");
        break;
      case 40:
        navigate("/personnelMonitoringLocation");
        break;
      case 41:
        navigate("/surfaceMonioringReport");
        break;
      case 42:
        navigate("/shiftRegister");
        break;
      case 43:
        navigate("/testTubeSwab");
        break;
      case 44:
        navigate("/testTubeReconcilation");
        break;
      case 45:
        navigate("/swabReconcilation");
        break;
      case 46:
        navigate("/temporaryManagement");
        break;
      case 47:
        navigate("/downloadReports");
        break;
      case 48:
        navigate("/liscenceConfiguration");
        break;
      case 50:
        navigate("/environmentalFlora");
        break;
      case 51:
        navigate("/noTest");
        break;
      case 52:
        navigate("/plateReconcilation");
        break;
      case 522:
        navigate("/plateReconcilation-test");
        break;
      // case 52:
      //   navigate("/qareviewandapproval");
      //   break;
      // Handle other cases as needed
      case 136:
        navigate("/mediaPowderInventory");
        break;
      case 137:
        navigate("/solutionInventory");
        break;
      case 138:
        navigate("/mediaProductMaster");
        break;
      case 139:
        navigate("/solutionProductMaster");
        break;
      case 352:
        navigate("/containerInventory");
        break;
      case 353:
        navigate("/gptTest");
        break;
      case 150:
        navigate("/reconcileMediaPowder");
        break;
      case 151:
        navigate("/reconcileSolution");
		  break;
        case 152:
          navigate("/reconcileContainer");
        break;
      case 153:
        navigate("/reconcileMediaBatch");
        break;
      case 154:
        navigate("/postAutoclaveStatus");
        break;
		 case 155:
		  navigate("/mediaRemoval");
		  break;
		case 156:
		  navigate("/mediaCleaning");
		  break;
		case 157:
		  navigate("/platePhysicalInspection");
		  break;
      case 354:
		    navigate("/mediaPreparationBatch");
			 break;
      case 158:
        navigate("/emptySterilization");
        break;
      case 159:
        navigate("/regulatoryMediaBatchStatisticsReport");
        break;
      case 160:
        navigate("/sterilityTesting");
        break;
      case 161:
        navigate("/mediaTubeInventory");
        break;
      case 162:
        navigate("/sterilityTestApproval");
        break;
      case 163:
        navigate("/sterilityIncubationArea");
        break;
      case 164:
        navigate("/sterilityAutoClave");
        break;
      case 165:
        navigate("/sterilityObservation");
        break;
      case 166:
        navigate("/mltBioburdenTests");
        break;
      case 167:
        navigate("/sterilizationUsageReport");
        break;
      case 168:
        navigate("/MLTBioburden");
        break;
      case 169:
        navigate("/mltBioburdenLabTest");
        break;
      default:
        break;
    }
  };

  const handleRawMaterialClick = () => {
    setShowRawMaterialModel(true);
  };

  const handlePlateSamplingClick = () => {
    setShowPlateSampleModal(true)
  }

  //get permission by role
  const getPermissionByRole = async (role: number) => {
    try {
      const response = await userService.getPermissionByRole(role);
      if (response.status && response.statusCode === 200) {
        setPermission(response.data.permissions);
        console.log(response.data.permissions, "permissions")
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={`sidebar ${activeNotifi ? "sibebarActive" : ""}`}>
      <div>
        {/* <div className="mt-3 mb-5">
          <p className="title">Zent EM</p>
          <p hidden={true} className="py-0 m-0 versionText">
            v.1.5
          </p>
        </div> */}
        <div className="px-2">
          <img
            src={logo}
            alt="Zent EM"
            className="h-24 w-auto max-w-[180px] object-contain"
          />
          <p hidden={true} className="py-0 m-0 versionText">
            v.1.5
          </p>
        </div>
        <div className="topContainer overflow-scroll max-h-[85vh]">
          {/* admin section */}
          {/* dashboard */}
          {(permission?.includes("realtime_dashboard") ||
           permission?.includes("historical_dashboard") ||
           permission?.includes("analytics_dashboard")) && (
            <a
              onClick={() => handleTabClick(0)}
              className={
                location.pathname === "/adminDashboard" ? "active" : ""
              }
            >
              <BiSolidDashboard
                className={
                  location.pathname === "/adminDashboard"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
               {t('navbar.Dashboard')}
            </a>
          )}

          {/* inventory */}
          {(permission?.includes("list_plates") ||
            permission?.includes("list_plates")) && (
            <a
              onClick={() => setShowInventory(!showInventory)}
              className={showInventory ? "groupDiv" : ""}
            >
              <FaMicroscope className="sidebarIcon mx-2" /> {t('navbar.Inventory.title')}
            </a>
          )}
          {showInventory && (
            <>
              {permission?.includes("list_plates") && (
                <a
                  onClick={() => handleTabClick(4)}
                  className={
                    location.pathname === "/plateInventory" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdInventory2
                    className={
                      location.pathname === "/plateInventory"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Inventory.Plate Inventory')}
                </a>
              )}

               {permission?.includes("list_plates") && (
                <a
                  onClick={() => handleTabClick(161)}
                  className={
                    location.pathname === "/mediaTubeInventory" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <LuTestTubes
                    className={
                      location.pathname === "/mediaTubeInventory"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Inventory.mediaTubeInventory')}
                </a>
              )}

              {permission?.includes("list_tcm") && (
                <a
                  onClick={() => handleTabClick(46)}
                  className={
                    location.pathname === "/temporaryManagement" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <GiTemporaryShield
                    className={
                      location.pathname === "/temporaryManagement"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Inventory.Temporary Change Management')}
                </a>
              )}

            {permission?.includes("list_plates") && (
                <a
                  onClick={() => handleTabClick(38)}
                  className={
                    location.pathname === "/discard" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <GiCardDiscard
                    className={
                      location.pathname === "/discard"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Inventory.Discard')}
                </a>
              )}

              {permission?.includes("list_test_tube") && (
                <a
                  onClick={() => handleTabClick(22)}
                  className={
                    location.pathname === "/testTubeInventory" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <GiTestTubes
                    className={
                      location.pathname === "/testTubeInventory"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Inventory.Saline Tube Inventory')}
                </a>
              )}


              {permission?.includes("list_swab_stick") && (
                <a
                  onClick={() => handleTabClick(43)}
                  className={
                    location.pathname === "/testTubeSwab" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <GiStickGrenade
                    className={
                      location.pathname === "/testTubeSwab"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Inventory.Swab Stick Inventory')}
                </a>
              )}

              {(permission?.includes("generate_plate_qr")) && (
                    <a
                      onClick={() => handleTabClick(133)}
                      className={
                        location.pathname === "/personnelMonitoringQr" ? "active" : ""
                      }
                      style={{ paddingLeft: "40px" }}
                    >
                      <MdOutlineQrCode2
                        className={
                          location.pathname === "/personnelMonitoringQr"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Inventory.Personnel Monitoring Qr')}
                    </a>
              )}

                  {/* no test */}
              {permission?.includes("add_no_test") && (
                  <a
                  onClick={() => handleTabClick(51)}
                  className={
                    location.pathname === "/noTest" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbHexagonOff
                    className={
                      location.pathname === "/noTest"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.noTest')}{" "}
                </a>
              )}
            </>
          )}

          {/* sterilitytesting */}

          {permission?.includes("list_shift") && (
            <a
              onClick={() => handleTabClick(160)}
              className={
                location.pathname === "/sterilityTesting" ? "active" : ""
              }
            >
              <SiTestcafe
                className={
                  location.pathname === "/sterilityTesting"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
              {t('sterilityTesting.navbar')}
            </a>
          )}

          {permission?.includes("list_shift") && (
            <a
              onClick={() => handleTabClick(165)}
              className={
                location.pathname === "/sterilityObservation" ? "active" : ""
              }
            >
              <MdOutlinePublishedWithChanges
                className={
                  location.pathname === "/sterilityObservation"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
              {t('sterilityObservation.navbar')}
            </a>
          )}

          {permission?.includes("list_shift") && (
            <a
              onClick={() => handleTabClick(162)}
              className={
                location.pathname === "/sterilityTestApproval" ? "active" : ""
              }
            >
              <PiCheckBold 
                className={
                  location.pathname === "/sterilityTestApproval"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
              {t('sterilityTestApproval.header.title')}
            </a>
          )}

          {permission?.includes("list_shift") && (
            <a
              onClick={() => handleTabClick(168)}
              className={
                location.pathname === "/MLTBioburden" ? "active" : ""
              }
            >
              <GiThermometerScale 
                className={
                  location.pathname === "/MLTBioburden"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
              {t('mltBioburdenList.navbar')}
            </a>
          )}

          {permission?.includes("list_shift") && (
            <a
              onClick={() => handleTabClick(169)}
              className={
                location.pathname === "/mltBioburdenLabTest" ? "active" : ""
              }
            >
              <ImLab 
                className={
                  location.pathname === "/mltBioburdenLabTest"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
              {t('mltLabTest.navbar')}
            </a>
          )}


          {/* Media Preparation */}
            {(
              permission?.includes("list_media_powder_inventory") ||
              permission?.includes("list_media_solution_inventory") ||
              permission?.includes("list_container_inventory") ||
              permission?.includes("list_gpt") ||
              permission?.includes("list_new_media_batch") ||
              permission?.includes("list_media_powder_product") ||
              permission?.includes("list_media_solution_product") ||
              permission?.includes("list_media_powder_reconciliation") ||
              permission?.includes("list_media_solution_reconciliation") ||
              permission?.includes("list_container_reconciliation") ||
              permission?.includes("list_media_batch_reconciliation") ||
              permission?.includes("media_removal") ||
              permission?.includes("media_cleaning") ||
              permission?.includes("plate_physical_inspection") ||
              permission?.includes("empty_sterilization")
            ) && (
            <a
              onClick={() => setShowMediaPreparation(!showMediaPreparation)}
              className={showMediaPreparation ? "groupDiv" : ""}
            >
              <GiChemicalTank className="sidebarIcon mx-2" />
              {t('navbar.Media Preparation.title')}
            </a>
            )}
            {showMediaPreparation && (
              <>
              {(
                permission?.includes("list_media_powder_inventory") ||
                permission?.includes("list_media_solution_inventory") ||
                permission?.includes("list_container_inventory")
              ) && (
                <a
                  onClick={() => setShowMediaInventory(!showMediaInventory)}
                  className={showMediaInventory ? "groupDiv" : ""}
                  style={{ paddingLeft: "40px" }}
                >
                  <MdInventory2 className="sidebarIcon mx-2" />
                  {t('navbar.Media Preparation.Inventory.title')}
                </a>
              )}  
                {showMediaInventory && (
                  <>
                  {permission?.includes("list_media_powder_inventory") && (
                    <a
                      onClick={() => handleTabClick(136)}
                      className={
                        location.pathname === "/mediaPowderInventory" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <GiPowderBag
                        className={
                          location.pathname === "/mediaPowderInventory"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Media Preparation.Inventory.Media Powder Inventory')}
                    </a>
                  )}

                  {permission?.includes("list_media_solution_inventory") && (
                    <a
                      onClick={() => handleTabClick(137)}
                      className={
                        location.pathname === "/solutionInventory" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <FaTint
                        className={
                          location.pathname === "/solutionInventory"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Media Preparation.Inventory.Solution Inventory')}
                    </a>
                  )}

                  {permission?.includes("list_container_inventory") && (
                    <a
                      onClick={() => handleTabClick(352)}
                      className={
                        location.pathname === "/containerInventory" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <LuPackage
                        className={
                          location.pathname === "/containerInventory"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Media Preparation.Inventory.containerInventory')}
                    </a>
                  )}
                  </>
                )}

                {/* GPT Test */}
                {permission?.includes("list_gpt") && (
                  <a
                    onClick={() => handleTabClick(353)}
                    className={
                      location.pathname === "/gptTest" ? "active" : ""
                    }
                     style={{ paddingLeft: "40px" }}
                  >
                    <FcInspection
                      className={
                        location.pathname === "/gptTest"
                          ? "sidebarIconActive mx-2"
                          : "sidebarIcon mx-2"
                      }
                    />{" "}
                    {t('navbar.Media Preparation.gptTest')}
                  </a>
                )}

                {/* Media preparation batch */}
                {permission?.includes("list_new_media_batch") && (
                  <a
                    onClick={() => handleTabClick(354)}
                    className={
                      location.pathname === "/mediaPreparationBatch" ? "active" : ""
                    }
                     style={{ paddingLeft: "40px" }}
                  >
                    <PiStackSimpleFill
                      className={
                        location.pathname === "/mediaPreparationBatch"
                          ? "sidebarIconActive mx-2"
                          : "sidebarIcon mx-2"
                      }
                    />{" "}
                    {t('navbar.Media Preparation.mediaPreparationBatch')}
                  </a>  
                )}

                {/*Regulatory Media batch Statistics Report */}
                {permission?.includes("list_new_media_batch") && (
                  <a
                    onClick={() => handleTabClick(159)}
                    className={
                      location.pathname === "/regulatoryMediaBatchStatisticsReport" ? "active" : ""
                    }
                     style={{ paddingLeft: "40px" }}
                  >
                    <BsClipboardPlus
                      className={
                        location.pathname === "/regulatoryMediaBatchStatisticsReport"
                          ? "sidebarIconActive mx-2"
                          : "sidebarIcon mx-2"
                      }
                    />{" "}
                    {t('navbar.Media Preparation.mediaStatistics')}
                  </a>  
                )}

                {/* Product Master*/}
                {(permission?.includes("list_media_powder_product") ||
                  permission?.includes("list_media_solution_product")) && (
                  <a
                    onClick={() => setShowProductMaster(!showProductMaster)}
                    className={showProductMaster ? "groupDiv" : ""}
                    style={{ paddingLeft: "40px" }}
                  >
                    <MdCategory className="sidebarIcon mx-2" />
                    {t('navbar.Media Preparation.ProductMaster.title')}
                  </a>
                )}
                {showProductMaster && (
                  <>
                  {permission?.includes("list_media_powder_product") && (
                    <a
                      onClick={() => handleTabClick(138)}
                      className={
                        location.pathname === "/mediaProductMaster" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <GiPowderBag className="sidebarIcon mx-2" />
                      {t('navbar.Media Preparation.ProductMaster.mediaPowderProductMaster')}
                    </a>
                  )}
                  {permission?.includes("list_media_solution_product") && (
                    <a
                      onClick={() => handleTabClick(139)}
                      className={
                        location.pathname === "/solutionProductMaster" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdOutlineOpacity className="sidebarIcon mx-2" />
                      {t('navbar.Media Preparation.ProductMaster.solutionProductMaster')}
                    </a>
                  )}
                  </>
                )}

                {/* Media Preparation - Reconcilation Menu Items */}
                {(permission?.includes("list_media_powder_reconciliation") ||
                  permission?.includes("list_media_solution_reconciliation") ||
                  permission?.includes("list_container_reconciliation") ||
                  permission?.includes("list_media_batch_reconciliation")) && ( 
                  <a
                    onClick={() => setShowMediaReconciliation(!showMediaReconciliation)}
                    className={showMediaReconciliation ? "groupDiv" : ""}
                    style={{ paddingLeft: "40px" }}
                  >
                    <MdBalance className="sidebarIcon mx-2" /> { t("navbar.Media Preparation.Reconciliation.title")}
                  </a>
                )}
                {showMediaReconciliation && (
                  <>
                  {permission?.includes("list_media_powder_reconciliation") && (
	                  <a
	                     onClick={() => {handleTabClick(150)}}
	                     className={
	                     location.pathname === "/reconcileMediaPowder" ? "active" : ""
	                     }
	                     style={{ paddingLeft: "65px" }}
	                  >
	                     <GiPowderBag className="sidebarIcon mx-2" />
	                     {t("navbar.Media Preparation.Reconciliation.mediaPowder")}
							      </a>
                  )}

                  {permission?.includes("list_media_solution_reconciliation") && (
							      <a
	                     onClick={() => {handleTabClick(151)}}
	                     className={
	                     location.pathname === "/reconcileSolution" ? "active" : ""
	                     }
	                     style={{ paddingLeft: "65px" }}
	                  >
	                     <FaTint className="sidebarIcon mx-2" />
	                     {t("navbar.Media Preparation.Reconciliation.solutions")}
							      </a>
                  )}

                  {permission?.includes("list_container_reconciliation") && (
							      <a
	                     onClick={() => {handleTabClick(152)}}
	                     className={
	                     location.pathname === "/reconcileContainer" ? "active" : ""
	                     }
	                     style={{ paddingLeft: "65px" }}
			              >
	                     <FaFlask className="sidebarIcon mx-2" />
	                     {t("navbar.Media Preparation.Reconciliation.container")}
			              </a>
                  )}

                  {permission?.includes("list_media_batch_reconciliation") && (
                  	<a
	                     onClick={() => {handleTabClick(153)}}
	                     className={
	                     location.pathname === "/reconcileMediaBatch" ? "active" : ""
	                     }
	                     style={{ paddingLeft: "65px" }}
			              >
	                     <FaLayerGroup className="sidebarIcon mx-2" />
	                     {t("navbar.Media Preparation.Reconciliation.mediaBatch")}
			              </a>
                  )}
                  </>
                )}

                {/* Media Preparation - Post Auto Clave Menu Items */}
                {(permission?.includes("media_removal") ||
                  permission?.includes("media_cleaning") ||
                  permission?.includes("list_post-autoclave_batch_status") ||
                  permission?.includes("plate_physical_inspection") ||
                  permission?.includes("empty_sterilization")) && ( 
                  <a
                    onClick={() => setShowPostAutoclave(!showPostAutoclave)}
                    className={showPostAutoclave ? "groupDiv" : ""}
                    style={{ paddingLeft: "40px" }}
                  >
                    <MdOutlineStopCircle className="sidebarIcon mx-2" />
                    {t("navbar.Media Preparation.PostAutoclave.title")}
                  </a>
                )}
                {showPostAutoclave && (
                <>
                  {permission?.includes("list_post-autoclave_batch_status") && (
                    <a
                      onClick={() => handleTabClick(154)}
                      className={
                        location.pathname === "/postAutoclaveStatus" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdOutlineSummarize className="sidebarIcon mx-2" />{t("navbar.Media Preparation.PostAutoclave.postAutoclaveStatus")}
                    </a>
                  )}
                  {permission?.includes("media_removal") && (
                    <a
                      onClick={() => handleTabClick(155)}
                      className={
                        location.pathname === "/mediaRemoval" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdOutlineEject className="sidebarIcon mx-2" />{t("navbar.Media Preparation.PostAutoclave.mediaRemoval")}
                    </a>
                  )}
                  {permission?.includes("media_cleaning") && (
                    <a
                      onClick={() => handleTabClick(156)}
                      className={
                        location.pathname === "/mediaCleaning" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdOutlineWaterDrop className="sidebarIcon mx-2" />{t("navbar.Media Preparation.PostAutoclave.mediaCleaning")}
                    </a>
                  )}
                  {permission?.includes("plate_physical_inspection") && (
                    <a
                      onClick={() => handleTabClick(157)}
                      className={
                        location.pathname === "/platePhysicalInspection" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdOutlineBiotech className="sidebarIcon mx-2" />{t("navbar.Media Preparation.PostAutoclave.platePhysicalInspection")}
                    </a>
                  )}
                  {permission?.includes("empty_sterilization") && (
                    <a
                      onClick={() => handleTabClick(158)}
                      className={
                        location.pathname === "/emptySterilization" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdDeleteOutline className="sidebarIcon mx-2" />{t("navbar.Media Preparation.PostAutoclave.emptySterilization")}
                    </a>
                  )}
                </>
                )}
              </>
            )}

          {/* visual inspection */}
          {permission?.includes("list_visual_inspection") && (
            <a
              onClick={() => handleTabClick(24)}
              className={
                location.pathname === "/visualInspectionTest" ? "active" : ""
              }
            >
              <FcInspection
                className={
                  location.pathname === "/visualInspectionTest"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
              {t('navbar.Visual Inspection Test')}
            </a>
          )}

          {/* scan area */}
          {(permission?.includes("scan_incubation") ||
            permission?.includes("scan_labtest") ||
            permission?.includes("environmental_flora_identification") ||
            permission?.includes("scan_autoclave")) && (
            <a
              onClick={() => handleTabClick(12)}
              className={location.pathname === "/scanArea" ? "active" : ""}
            >
              <BiQrScan
                className={
                  location.pathname === "/scanArea"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />{" "}
              {t('navbar.Scan Area / Equipment.title')}
            </a>
          )}
          {location_type === "12" && (
            <>
              {permission?.includes("scan_incubation") && (
                <a
                  onClick={() => handleTabClick(6)}
                  className={
                    location.pathname === "/incubationArea" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <BiFridge
                    className={
                      location.pathname === "/incubationArea"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Scan Area / Equipment.Incubation')}
                </a>
              )}

               {/* sterility incubation */}
              {permission?.includes("scan_incubation") && (
                <a
                  onClick={() => handleTabClick(163)}
                  className={
                    location.pathname === "/sterilityIncubationArea" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdSensorDoor
                    className={
                      location.pathname === "/sterilityIncubationArea"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Scan Area / Equipment.SterilityIncubation')}
                </a>
              )}

            </>
          )}
          {location_type === "8" && (
            <div>
              {permission?.includes("scan_labtest") && (
                <a
                  onClick={() => handleTabClick(7)}
                  className={
                    location.pathname === "/labtestArea" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <RiMicroscopeFill
                    className={
                      location.pathname === "/labtestArea"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Scan Area / Equipment.Lab Test Area')}
                </a>
              )}
              {permission?.includes("environmental_flora_identification") && (
                <a
                  onClick={() => handleTabClick(13)}
                  className={
                    location.pathname === "/environmental-flora" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <RiLeafFill
                    className={
                      location.pathname === "/environmental-flora"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Scan Area / Equipment.Environmental Flora')}
                </a>
              )}
            </div>
          )}
          {location_type === "9" && (
            <>
              {permission?.includes("scan_autoclave") && (
                <a
                  onClick={() => handleTabClick(8)}
                  className={location.pathname === "/autoClave" ? "active" : ""}
                  style={{ paddingLeft: "40px" }}
                >
                  <MdMotionPhotosAuto
                    className={
                      location.pathname === "/autoClave"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Scan Area / Equipment.Autoclave')}
                </a>
              )}
              {permission?.includes("scan_autoclave") && (
                <a
                  onClick={() => handleTabClick(164)}
                  className={
                    location.pathname === "/sterilityAutoClave" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdScience
                    className={
                      location.pathname === "/sterilityAutoClave"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Scan Area / Equipment.SterilityAutoclave')}
                </a>
              )}
            </>
          )}

          {/* plate sampling */}
          {permission?.includes("plate_sampling_test") && (
            <a onClick={() => handlePlateSamplingClick()}>
              <MdOutlineFactCheck className="sidebarIcon mx-2" /> {t('navbar.Plate Sampling')}
            </a>
          )}

          {/* sample Type test */}
          {permission?.includes("sample_type_test") && (
            <a onClick={() => handleRawMaterialClick()}>
              <SiTestcafe className="sidebarIcon mx-2" /> {t('navbar.Raw Material Test')}
            </a>
          )}

          {/* deviation */}
          {permission?.includes("list_incident") && (
            <a
              onClick={() => handleTabClick(25)}
              className={
                location.pathname === "/deviationReporting" ? "active" : ""
              }
            >
              <MdOutlinePublishedWithChanges
                className={
                  location.pathname === "/deviationReporting"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />
              {t('navbar.Deviation / Incident Reporting')}{" "}
            </a>
          )}

          {/* exceptionHandling */}
          {permission?.includes("list_exceptions") && (
            <a
              onClick={() => handleTabClick(11)}
              className={
                location.pathname === "/exceptionHandling" ? "active" : ""
              }
            >
              <MdOutlineError
                className={
                  location.pathname === "/exceptionHandling"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />
             {t('navbar.Exception Handling')}
            </a>
          )}




          {/* lab operator section */}
          {permission?.includes("qa_approval") && (
            <a
              onClick={() => handleTabClick(10)}
              className={location.pathname === "/labReport" ? "active" : ""}
            >
              <ImLab
                className={
                  location.pathname === "/labReport"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />
              {t('navbar.Lab Approval')}
            </a>
          )}

          {permission?.includes("qa_approval") && (
            <a
              onClick={() => handleTabClick(50)}
              className={location.pathname === "/environmentalFlora" ? "active" : ""}
            >
              <VscServerEnvironment
                className={
                  location.pathname === "/environmentalFlora"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />
              Environmental Flora Approval
            </a>
          )}
          {/* {permission?.includes("qa_review") && (
            <a
              onClick={() => handleTabClick(52)}
              className={location.pathname === "/qareviewandapproval" ? "active" : ""}
            >
              <FaVialCircleCheck
                className={
                  location.pathname === "/qareviewandapproval"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />
              QA Review & Approval
            </a>
          )} */}

          {permission?.includes("manage_workflow") && (
            <a onClick={() => handleTabClick(23)} className={location.pathname === '/workFlow' ? 'active': ''}>
                <GoWorkflow className={location.pathname === '/workFlow' ? 'sidebarIconActive mx-2': 'sidebarIcon mx-2'} />{t('navbar.WorkFlow')}</a>
          )}

          {(permission?.includes("list_roles") ||
            permission?.includes("list_user") ||
            permission?.includes("list_policy") ||
            permission?.includes("list_area") ||
            permission?.includes("list_equipment") ||
            permission?.includes("list_rawmaterial_type") ||
            permission?.includes("list_grade_type") ||
            permission?.includes("list_frequency_schedule") ||
            permission?.includes("list_production_schedule") ||
            permission?.includes("list_operator_schedule")) && (
            <a
              onClick={() => setShowUserEndMenu(!showUserEndMenu)}
              className={showUserEndMenu ? "groupDiv" : ""}
            >
              <RiUserSettingsFill className="sidebarIcon mx-2" /> {t('navbar.Configuration.title')}
            </a>
          )}
          {showUserEndMenu && (
            <>
                {(permission?.includes("list_frequency_schedule") ||
                permission?.includes("list_production_schedule") ||
                permission?.includes("generate_plate_qr") ||
                permission?.includes("view_production_calendar") ||
                permission?.includes("list_operator_schedule")) && (
                <a
                  onClick={() => setShowActivitySchedule(!showActivitySchedule)}
                  className={showActivitySchedule ? "groupDiv" : ""}
                  style={{ paddingLeft: "40px" }}
                >
                  <GiClockwork className="sidebarIcon mx-2" /> {t('navbar.Configuration.Activity Schedule.title')}
                </a>
              )}

              {showActivitySchedule && (
                <>
                  {(permission?.includes("list_frequency_schedule")) && (
                    <a
                      onClick={() => handleTabClick(128)}
                      className={
                        location.pathname === "/schedule_frequency" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <GiLightningFrequency
                        className={
                          location.pathname === "/schedule_frequency"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                       {t('navbar.Configuration.Activity Schedule.Frequency Policy')}
                    </a>
                  )}

                  {/* {(permission?.includes("list_production_schedule")) && (
                    <a
                      onClick={() => handleTabClick(129)}
                      className={
                        location.pathname === "/schedule_production" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <GiCuckooClock
                        className={
                          location.pathname === "/schedule_production"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Configuration.Activity Schedule.Production Schedule')}
                    </a>
                  )} */}

                   {(permission?.includes("list_production_schedule")) && (
                    <a
                      onClick={() => handleTabClick(134)}
                      className={
                        location.pathname === "/schedule_production2" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <GiCuckooClock
                        className={
                          location.pathname === "/schedule_production2"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      Production Schedule
                    </a>
                  )}

                  {/* {(permission?.includes("list_operator_schedule")) && (
                    <a
                      onClick={() => handleTabClick(130)}
                      className={
                        location.pathname === "/schedule_operator" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <GiAlarmClock
                        className={
                          location.pathname === "/schedule_operator"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Configuration.Activity Schedule.Assign Operator')}
                    </a>
                  )} */}

                   {(permission?.includes("list_operator_schedule")) && (
                    <a
                      onClick={() => handleTabClick(135)}
                      className={
                        location.pathname === "/schedule_operator2" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdQrCode
                        className={
                          location.pathname === "/schedule_operator2"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      Generate Plate QR
                    </a>
                  )}

                  {(permission?.includes("view_production_calendar")) && (
                    <a
                      onClick={() => handleTabClick(132)}
                        className={
                          location.pathname === "/productionCalendar" ? "active" : ""
                        }
                        style={{ paddingLeft: "65px" }}
                      >
                      <SlCalender className="sidebarIcon mx-2" /> {t('navbar.Configuration.Activity Schedule.Production Calendarv')}
                    </a>
                  )}

                  {/* {(permission?.includes("generate_plate_qr")) && (
                    <a
                      onClick={() => handleTabClick(131)}
                      className={
                        location.pathname === "/generatePlateQr" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdQrCode
                        className={
                          location.pathname === "/generatePlateQr"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Configuration.Activity Schedule.Generate Plate Qr')}
                    </a>
                  )} */}

                  {(permission?.includes("generate_plate_qr")) && (
                    <a
                      onClick={() => handleTabClick(133)}
                      className={
                        location.pathname === "/personnelMonitoringQr" ? "active" : ""
                      }
                      style={{ paddingLeft: "65px" }}
                    >
                      <MdOutlineQrCode2
                        className={
                          location.pathname === "/personnelMonitoringQr"
                            ? "sidebarIconActive mx-2"
                            : "sidebarIcon mx-2"
                        }
                      />
                      {t('navbar.Configuration.Activity Schedule.Personnel Monitoring Qr')}
                    </a>
                  )}
                </>
              )}


              {permission?.includes("list_roles") && (
                <a
                  onClick={() => handleTabClick(18)}
                  className={
                    location.pathname === "/rolesAndPermission" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <FaFingerprint
                    className={
                      location.pathname === "/rolesAndPermission"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Roles and Permission')}
                </a>
               )}

              {permission?.includes("list_user") && (
                <a
                  onClick={() => handleTabClick(2)}
                  className={
                    location.pathname === "/userManagement" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <FaUserFriends
                    className={
                      location.pathname === "/userManagement"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Configuration.User Management')}
                </a>
              )}
              {/* {permission?.includes("list_policy") && (
                <a
                  onClick={() => handleTabClick(3)}
                  className={
                    location.pathname === "/policyManagement" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdPolicy
                    className={
                      location.pathname === "/policyManagement"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  Policy Management
                </a>
              )} */}
              {permission?.includes("list_area") && (
                <a
                  onClick={() => handleTabClick(1)}
                  className={
                    location.pathname === "/areaManagement" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdSensorDoor
                    className={
                      location.pathname === "/areaManagement"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Configuration.Area / Location Management')}
                </a>
              )}
              {permission?.includes("list_equipment") && (
                <a
                  onClick={() => handleTabClick(14)}
                  className={
                    location.pathname === "/equipmentCalibration"
                      ? "active"
                      : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <GiThermometerScale
                    className={
                      location.pathname === "/equipmentCalibration"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Configuration.Equipment Configuration')}
                </a>
              )}
              {permission?.includes("list_rawmaterial_type") && (
                <a
                  onClick={() => handleTabClick(15)}
                  className={
                    location.pathname === "/addRawMaterials" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <BsHouseAddFill
                    className={
                      location.pathname === "/addRawMaterials"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Configuration.Sample Type Configuration')}
                </a>
              )}
              {permission?.includes("list_grade_type") && (
                <a
                  onClick={() => handleTabClick(19)}
                  className={
                    location.pathname === "/addGradeType" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <PiScales
                    className={
                      location.pathname === "/addGradeType"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Configuration.Limits Configuration')}
                </a>
              )}
              {permission?.includes("list_personnel_monitoring") && (
                <a
                  onClick={() => handleTabClick(40)}
                  className={
                    location.pathname === "/personnelMonitoringLocation" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <FaMagnifyingGlassLocation
                    className={
                      location.pathname === "/personnelMonitoringLocation"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Configuration.Personnel Monitoring Location')}
                </a>
              )}
            </>
          )}
          {permission?.includes("list_device") && (
            <a
              onClick={() => setShowConfig(!showconfig)}
              className={showconfig ? "groupDiv" : ""}
            >
              <FaCog className="sidebarIcon mx-2" />
              {t('navbar.Application Configuration.title')}
            </a>
          )}
          {showconfig && (
            <>
              {permission?.includes("list_device") && (
                <a
                  onClick={() => handleTabClick(20)}
                  className={
                    location.pathname === "/deviceRegistration" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdImportantDevices
                    className={
                      location.pathname === "/deviceRegistration"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Application Configuration.Device Registration')}
                </a>
              )}

              {permission?.includes("list_holiday") && (
                <a
                  onClick={() => handleTabClick(37)}
                  className={
                    location.pathname === "/holidayRegister" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <FcLeave
                    className={
                      location.pathname === "/holidayRegister"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Application Configuration.Holiday Register')}
                </a>
              )}

              {permission?.includes("list_notification") && (
                <a
                  onClick={() => handleTabClick(39)}
                  className={
                    location.pathname === "/notificationConfiguration" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdOutlineNotificationAdd
                    className={
                      location.pathname === "/notificationConfiguration"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Application Configuration.Notification Configuration')}
                </a>
              )}

              {permission?.includes("list_shift") && (
                <a
                  onClick={() => handleTabClick(42)}
                  className={
                    location.pathname === "/shiftRegister" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <LuBookOpenCheck
                    className={
                      location.pathname === "/shiftRegister"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Application Configuration.Shift Register')}
                </a>
              )}

              {/* {permission?.includes("list_shift") && (
                <a
                  onClick={() => handleTabClick(48)}
                  className={
                    location.pathname === "/liscenceConfiguration" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <FcExpired
                    className={
                      location.pathname === "/liscenceConfiguration"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  Subscription & Liscence
                </a>
              )} */}
            </>
          )}
          {permission?.includes("view_sop") && (
            <a
              onClick={() => handleTabClick(27)}
              className={location.pathname === "/sopReport" ? "active" : ""}
            >
              <RiFileTransferLine
                className={
                  location.pathname === "/sopReport"
                    ? "sidebarIconActive mx-2"
                    : "sidebarIcon mx-2"
                }
              />
              {t('navbar.SOP')}
            </a>
          )}

         {/* reconciliation */}
         {(permission?.includes("view_plate_reconciliation")) && (
            <a
              onClick={() => setShowReconciliation(!showReconciliation)}
              className={showReconciliation ? "groupDiv" : ""}
            >
              <ImInsertTemplate className="sidebarIcon mx-2" />
              {t('navbar.Reconciliation.title')}
            </a>
          )}
          {showReconciliation && (
            <>
              {/* {permission?.includes("view_plate_reconciliation") && (
              <a
                onClick={() => handleTabClick(26)}
                className={
                  location.pathname === "/plateReconcilation" ? "active" : ""
                }
                style={{ paddingLeft: "40px" }}
              >
                <ImInsertTemplate
                  className={
                    location.pathname === "/plateReconcilation"
                      ? "sidebarIconActive mx-2"
                      : "sidebarIcon mx-2"
                  }
                />
                Plate Reconciliation
              </a>
              )} */}
              {permission?.includes("view_plate_reconciliation") && (
                <a
                  onClick={() => handleTabClick(28)}
                  className={
                    location.pathname === "/reconcilationSummary" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdOutlineSummarize
                    className={
                      location.pathname === "/reconcilationSummary"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Reconciliation.Reconciliation Summary')}
                </a>
              )}

               {/* {permission?.includes("view_plate_reconciliation") && (
                <a
                  onClick={() => handleTabClick(288)}
                  className={
                    location.pathname === "/reconcilationSummary-test" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <MdOutlineSummarize
                    className={
                      location.pathname === "/reconcilationSummary-test"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Reconciliation.Reconciliation Summary')} - New
                </a>
              )} */}

              {permission?.includes("view_test_tube_reconciliation") && (
                <a
                  onClick={() => handleTabClick(44)}
                  className={
                    location.pathname === "/testTubeReconcilation" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <HiOutlineClipboardDocument
                    className={
                      location.pathname === "/testTubeReconcilation"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Reconciliation.Saline Tube Reconciliation')}
                </a>
              )}

              {permission?.includes("view_swab_stick_reconciliation") && (
                <a
                  onClick={() => handleTabClick(45)}
                  className={
                    location.pathname === "/swabReconcilation" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <HiOutlineDocumentChartBar
                    className={
                      location.pathname === "/swabReconcilation"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Reconciliation.Swab Stick Reconciliation')}
                </a>
              )}
            </>
          )}

          {/* reports */}
          {permission?.includes("view_reports") && (
            <a
              onClick={() => setShowReports(!showReports)}
              className={showReports ? "groupDiv" : ""}
            >
              <TbReportAnalytics className="sidebarIcon mx-2" /> {t('navbar.Reports.title')}
            </a>
          )}
          {showReports && (
            <>
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(166)}
                  className={
                    location.pathname === "/mltBioburdenTests" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/mltBioburdenTests"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Reports.MLT Bioburden Tests')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(167)}
                  className={
                    location.pathname === "/sterilizationUsageReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/sterilizationUsageReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Reports.Sterilization Usage Report')}
                </a>
              )}
            </>
          )}

          {/* reports */}
          {/* {(permission?.includes("view_reports") ||
            permission?.includes("view_reports")) && (
            <a
              onClick={() => setShowReport(!showReport)}
              className={showReport ? "groupDiv" : ""}
            >
              <TbReportAnalytics className="sidebarIcon mx-2" /> Report
            </a>
          )} */}
          {showReport && (
            <>
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(29)}
                  className={
                    location.pathname === "/airSamplingreport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/airSamplingreport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Active Air Sampling Report')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(30)}
                  className={
                    location.pathname === "/passiveSamplingreport"
                      ? "active"
                      : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/passiveSamplingreport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Passive Air Sampling Report')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(31)}
                  className={
                    location.pathname === "/personnelMonitoringReport"
                      ? "active"
                      : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/personnelMonitoringReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Personnel Monitoring Report')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(32)}
                  className={
                    location.pathname === "/surfaceMonitoring" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/surfaceMonitoring"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  Contact Plate Monitoring Report
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(33)}
                  className={
                    location.pathname === "/equipmentReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/equipmentReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Equipment Report')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(34)}
                  className={
                    location.pathname === "/visualInspectionReport"
                      ? "active"
                      : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/visualInspectionReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Visual Inspection Report')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(35)}
                  className={
                    location.pathname === "/deviationReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/deviationReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Deviation Report')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(36)}
                  className={
                    location.pathname === "/plateActivityReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/plateActivityReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Plate Activity Report')}
                </a>
              )}
               {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(41)}
                  className={
                    location.pathname === "/surfaceMonioringReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/surfaceMonioringReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  Contact Plate Monitoring
                </a>
              )}
            </>
          )}

          {/* audit trial log */}
          {(permission?.includes("view_configuration_change_report") ||
            permission?.includes("view_user_access_report") ||
            permission?.includes("list_log_report")) && (
            <a
              onClick={() => setAuditTrial(!showAuditTrial)}
              className={showAuditTrial ? "groupDiv" : ""}
            >
              <AiOutlineAudit className="sidebarIcon mx-2" />
              {t('navbar.Audit Trial Logs.title')}
            </a>
          )}
          {showAuditTrial && (
            <>
              {permission?.includes("view_configuration_change_report") && (
                <a
                  onClick={() => handleTabClick(16)}
                  className={
                    location.pathname === "/auditTrialReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <GiGears
                    className={
                      location.pathname === "/auditTrialReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Audit Trial Logs.Configuration Change Report')}
                </a>
              )}
              {permission?.includes("view_user_access_report") && (
                <a
                  onClick={() => handleTabClick(17)}
                  className={
                    location.pathname === "/userAccessReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <FaUserFriends
                    className={
                      location.pathname === "/userAccessReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Audit Trial Logs.User Access Report')}
                </a>
              )}
              {permission?.includes("list_log_report") && (
                <a
                  onClick={() => handleTabClick(21)}
                  className={location.pathname === "/logReport" ? "active" : ""}
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReportAnalytics
                    className={
                      location.pathname === "/logReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Audit Trial Logs.Log Report')}
                </a>
              )}
              {permission?.includes("view_reports") && (
                <a
                  onClick={() => handleTabClick(36)}
                  className={
                    location.pathname === "/plateActivityReport" ? "active" : ""
                  }
                  style={{ paddingLeft: "40px" }}
                >
                  <TbReport
                    className={
                      location.pathname === "/plateActivityReport"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />
                  {t('navbar.Audit Trial Logs.Activity Log Report')}
                </a>
              )}
            </>
          )}




          {(permission?.includes("qa_review") ||
            permission?.includes("download_report")) && (
                <a
                  onClick={() => handleTabClick(47)}
                  className={
                    location.pathname === "/downloadReports" ? "active" : ""
                  }
                  // style={{ paddingLeft: "40px" }}
                >
                  <FaFileDownload
                    className={
                      location.pathname === "/downloadReports"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('navbar.Download Reports')}
                </a>
              )}
              {permission?.includes("analytics_dashboard") && (
                <a
                  onClick={() => handleTabClick(52)}
                  className={
                    location.pathname === "/plateReconcilation" ? "active" : ""
                  }
                >
                  <TbReportAnalytics
                    className={
                      location.pathname === "/plateReconcilation"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('Plate Activity Report')}
                </a>
              )}
               {/* {permission?.includes("analytics_dashboard") && (
                <a
                  onClick={() => handleTabClick(522)}
                  className={
                    location.pathname === "/plateReconcilation-test" ? "active" : ""
                  }
                >
                  <TbReportAnalytics
                    className={
                      location.pathname === "/plateReconcilation-test"
                        ? "sidebarIconActive mx-2"
                        : "sidebarIcon mx-2"
                    }
                  />{" "}
                  {t('Plate Activity Report - New')}
                </a>
              )} */}
        </div>

        {/* Branding Panel */}
        {/* <div className="border-t border-slate-100 bg-slate-50/50 px-3 py-1.5">
          <div className="flex flex-col gap-0.5">
            <h3 className="text-[18px] font-bold leading-none tracking-tight m-0">
              <span className="text-[#163B65]">Zent</span>
              <span className="text-[#F97316]"> EM</span>
            </h3>

            <p className="text-[10px] font-semibold text-[#7C94B2] uppercase tracking-[1px] leading-none m-0">
              EM PLATFORM
            </p>

            <div className="flex flex-col gap-[1px] mt-0.5">
              <p className="text-[12px] font-semibold text-[#163B65] leading-none m-0">
                Ensure Sterility.
              </p>
              <p className="text-[12px] font-semibold text-[#F97316] leading-none m-0">
                Ensure Compliance.
              </p>
              <p className="text-[12px] font-semibold text-[#163B65] leading-none m-0">
                Build Confidence.
              </p>
            </div>
          </div>
        </div> */}
      </div>

      <AddException
        showModel={showRawMaterialModel}
        isPlateSampling={false}
        isRawMaterialTest={true}
        setShowModel={() => setShowRawMaterialModel(false)}
      />

      <AddException
        showModel={showPlateSampleModal}
        isPlateSampling={true}
        setShowModel={() => setShowPlateSampleModal(false)}
      />

    </div>
  );
};

export default Navbar;
